import React from 'react'
//import I18n from "i18n-js/index.js.erb"
import numeral from "numeral"

export default class ReservationBuilderTotal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      tax_totals_open: this.props.tax_totals_open,
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00'
    };
    this.onClose = this.onClose = this.onClose.bind(this);
    this.onOpen = this.onOpen = this.onOpen.bind(this);
  };


  render() {


    return (
      <div className="card well-lg reservation-total summary-of-charges" >
        <table>
          <tbody>
          <tr className="total-charged">
            <td><label className="reservation-total-label" >{I18n.t('lodging_total')}:</label></td>
            <td className="text-right amount-td" style={{paddingRight: '26px'}}><div className="value">${numeral((this.props.reservation.subtotal_amount - this.props.reservation.add_ons_subtotal_amount) / 100).format(this.state.numberFormat)}</div></td>
          </tr>
          {/* <tr style={{display: this.props.reservation && this.props.reservation.promotion_discount_amount ? 'table-row' : 'none'}}>
            <td><label className="reservation-total-label">{I18n.t('promotion_discount')}:</label></td>
            <td className="text-right amount-td"><div className="value" style={{color: 'red'}}>-${numeral(this.props.reservation.promotion_discount_amount / 100).format(this.state.numberFormat)}</div></td>
          </tr>
          <tr style={{display: this.props.reservation && this.props.reservation.discount_applied_amount ? 'table-row' : 'none'}}>
            <td><label className="reservation-total-label">{I18n.t('manager_discount')}:</label></td>
            <td className="text-right amount-td" ><div className="value" style={{color: 'red'}}>-${numeral(this.props.reservation.discount_applied_amount / 100).format(this.state.numberFormat)}</div></td>
          </tr> */}
          <tr style={{display: this.props.reservation && this.props.reservation.add_ons_subtotal_amount ? 'table-row' : 'none'}}>
            <td><label className="reservation-total-label" >{I18n.t('add_ons_total')}:</label></td>
            <td className="text-right amount-td" style={{paddingRight: '26px'}} ><div className="value">${numeral(this.props.reservation.add_ons_subtotal_amount / 100).format(this.state.numberFormat)}</div></td>
          </tr>
          {/* <tr>
            <td><label className="reservation-total-label">{I18n.t('taxes_and_fees')}:</label>
            <p style={{fontSize: '12px'}}>({I18n.t('taxes_are_estimated')})</p></td>
            <td className="text-right amount-td"><div className="value">${numeral(this.props.reservation.taxes_and_fees_amount / 100).format(this.state.numberFormat)}</div></td>
          </tr>
          <tr>
            <td colSpan="2"><hr /></td>
          </tr>
          <tr className="total-charged">
              <td style={{ paddingBottom: 0 }}><label className="reservation-total-label">{I18n.t('reservation_total')}:</label></td>
            <td style={{paddingBottom: 0}} className="text-right amount-td"><div className="value">${numeral(this.props.reservation.total_amount / 100).format(this.state.numberFormat)}</div></td>
          </tr>
          {
            this.props.reservation.amount_due_at_booking
            ?
            <tr className="total-due-at-booking">
                  <td style={{ paddingBottom: 0 }}><label className="reservation-total-label">{I18n.t('due_today')}:</label></td>
              <td style={{ paddingBottom: 0 }} className="text-right amount-td"><div className="value">${numeral(this.props.reservation.amount_due_at_booking  / 100).format(this.state.numberFormat)}</div></td>
            </tr>
            :
            null
          } */}
          </tbody>
        </table>
        <div className="row">
          <div className="col-md-12">
            {/* <div className="summary-of-charges"> */}
              {this.renderTaxesAndFeesTotals()}

            {/* </div> */}

          </div>
        </div>





        <table>
          <tbody>
            <tr className="total-charged">
              <td style={{ paddingBottom: 0 }}><label className="reservation-total-label" >{I18n.t('reservation_total')}:</label></td>
              <td style={{paddingBottom: 0, paddingRight: '26px'}} className="text-right amount-td" ><div className="value">${numeral(this.props.reservation.total_amount / 100).format(this.state.numberFormat)}</div></td>
            </tr>
            {
              this.props.bookingPaymentAmount
              ?
              <tr className="total-due-at-booking">
                <td style={{ paddingBottom: 0 }}><label className="reservation-total-label" >{I18n.t('due_today')}:</label></td>
                <td style={{ paddingBottom: 0, paddingRight: '26px' }} className="text-right amount-td" ><div className="value">${numeral(this.props.bookingPaymentAmount  / 100).format(this.state.numberFormat)}</div></td>
              </tr>
              :
              null
            }

          </tbody>
        </table>
      </div>
    );
  };

  renderTaxesAndFeesTotals() {
    if (this.props.reservation.taxes_and_fees_totals && Object.keys(this.props.reservation.taxes_and_fees_totals).length > 0) {
      var idx = 0
      var taxes_and_fees_totals = Object.keys(this.props.reservation.taxes_and_fees_totals).map((key) => {
        idx = idx + 1;
        return (
          <tr key={idx}>
            <td stye={{fontWeight: 'normal'}}>{key}:</td>
            <td className="text-right amount-td" style={{fontWeight: 'normal', padding: '1px 14px'}}><div className="value">${numeral(this.props.reservation.taxes_and_fees_totals[key] / 100).format(this.state.numberFormat)}</div></td>

            {/* <td style={{ paddingBottom: 0 }}><label className="reservation-total-label">{key}:</label></td>
            <td className="text-right amount-td" style={{ paddingBottom: 0 }}><div className="value">${numeral(this.props.reservation.taxes_and_fees_totals[key] / 100).format(this.state.numberFormat)}</div></td> */}
          </tr>
        )
      });
    }

    return(
      <div className="segments">
        <div className="reservation-segment expanded" ref="reservation_segment" >
          <div className="header">

            <div className="flexed segment-price-details-wrapper">
              <span className="seg-details-wrapper" >
                {!this.props.tax_totals_open ? this.renderArrow() : null}
                {/* <table>
                  <tbody>
                    <tr>
                      <td><label className="reservation-total-label">{I18n.t('taxes_and_fees')}:</label>
                      <p style={{fontSize: '12px'}}>({I18n.t('taxes_are_estimated')})</p></td>
                      <td className="text-right amount-td"><div className="value">${numeral(this.props.reservation.taxes_and_fees_amount / 100).format(this.state.numberFormat)}</div></td>
                    </tr>
                  </tbody>
                </table> */}
                {`${I18n.t('taxes_and_fees')} (${I18n.t('taxes_are_estimated')})`}: &nbsp;
                {/* <p style={{fontSize: '12px'}}>({I18n.t('taxes_are_estimated')})</p> */}
              </span>
              <span style={{display: 'block', float: 'right', paddingRight: '10px'}}>
                ${numeral(this.props.reservation.taxes_and_fees_amount / 100).format(this.state.numberFormat)}
              </span>



            </div>

          </div>
          <div className="body" ref="body" style={{display: this.state.tax_totals_open ? 'block' : 'none'}}>
            <table className="taxes-and-fees-table">
              <tbody>
                {taxes_and_fees_totals}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    )
  }

  renderArrow() {
    if (this.state.tax_totals_open) {
      return (
        <div className="toggle-arrow arrow-down" onClick={this.onClose}></div>
      );
    } else {
      return (
        <div className="toggle-arrow arrow-right"  onClick={this.onOpen}></div>
      );
    }
  }

  onClose() {
    var self = this;

    $(this.refs.body).slideUp('fast', function () {
      self.setState({tax_totals_open: false});
    });
  }

  onOpen() {
    var self = this;

    $(this.refs.body).slideDown('fast', function () {
      self.setState({tax_totals_open: true});
    });
  }


};
